import LineInterface from 'app/interfaces/LineInterface';
import {isActiveLine} from './isActiveLine';

export const isActiveForExpress = (line: LineInterface): boolean => {
    const {ee} = line;
    return ee && isActiveLine(line);
};
